module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/toefl/sections/ai/assets/ets_badge-a7b0ea27052a15dde19c87a47e65e5a1.svg";